import { all, call, put, takeLatest } from "redux-saga/effects";
import * as types from "../../actions/actionTypes";
import {
  GeneralUtilsAction,
  InitAction,
  ManagerPaymentAction,
  UploadImageAction
} from "../../actions";
import * as paymentApi from "../../api/payment/managerPayment";
import { toastr } from "react-redux-toastr";
import { go, goBack, push, replace } from "connected-react-router";
import { createBrowserHistory } from "history";
import { SUMMARY_PAYMENT_MANAGER } from "../../constants/urls";
import { SetMessage } from "../../assets/errorMessages";
import imageCompression from "browser-image-compression";

export function* managerWatcherPayment() {
  yield takeLatest(types.MANAGER_REMOVE_PAYMENT_REQUEST, remove);
  yield takeLatest(types.MANAGER_GET_IMAGE_PAYMENT_REQUEST, getImage);
  yield takeLatest(types.MANAGER_STORE_PAYMENT_REQUEST, store);
  yield takeLatest(types.MANAGER_GET_PAYMENT_REQUEST, get);
  yield takeLatest(types.MANAGER_UPDATE_PAYMENT_REQUEST, update);
}

async function removeReq(id) {
  return paymentApi.remove(id);
}

function* remove(action) {
  const history = createBrowserHistory();
  try {
    const response = yield call(removeReq, action.id);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(ManagerPaymentAction.removeSuccess(response.data, action.id));
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));
    if (action.goBack) {
      if (history.location.state && history.location.state.from) {
        yield put(push(history.location.state.from));
      } else {
        // hide remove confirm and go back from summary page
        yield put(go(-1));
      }
    }
  } catch (error) {
    SetMessage(error, true);
    yield put(ManagerPaymentAction.removeFailure(error, action.id));
  }
}

async function storeReq(data) {
  return paymentApi.store(data);
}

function* store(action) {
  try {
    yield put(UploadImageAction.showModal(action.files));
    yield put(GeneralUtilsAction.dateAndTimeMaintain());
    const response = yield call(storeReq, action.data);
    yield put(UploadImageAction.uploadImageRequest(action.files));
    yield all(
      action.files.map((file, i) =>
        storeImageReq(response.data.data.id, file, i)
      )
    );
    yield put(UploadImageAction.hideModal());
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });

    yield put(ManagerPaymentAction.storeSuccess());
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));

    if (action.reload) {
      yield put(GeneralUtilsAction.dateAndTimeMaintain(action.reload));
    } else {
      yield put(
        replace({
          pathname: `${SUMMARY_PAYMENT_MANAGER}/${response.data.data.id}`
        })
      );
    }
  } catch (error) {
    SetMessage(error, true);
    yield put(ManagerPaymentAction.storeFailure());
    yield put(UploadImageAction.hideModal());
  }
}
async function updateReq(id, data) {
  return paymentApi.update(id, data);
}
function* update(action) {
  try {
    yield put(UploadImageAction.showModal(action.files));
    const response = yield call(updateReq, action.id, action.data);
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));
    yield put(UploadImageAction.uploadImageRequest(action.files));

    yield all(
      action.files.map((file, i) =>
        storeImageReq(response.data.data.id, file, i)
      )
    );
    yield put(UploadImageAction.hideModal());

    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });

    yield put(ManagerPaymentAction.updateSuccess());
    yield put(goBack());
  } catch (error) {
    SetMessage(error, true);
    yield put(ManagerPaymentAction.updateFailure());
    yield put(UploadImageAction.hideModal());
  }
}

function* storeImageReq(id, file, index) {
  if (!file.id) {
    const options = {
      maxSizeMB: 0.7,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    };
    try {
      const compressedResult = yield call(imageCompression, file, options);
      const responseImg = yield call(
        paymentApi.storeImage,
        compressedResult,
        id
      );
      if (responseImg.data && responseImg.data.premium) {
        yield put(
          InitAction.getSuccess({ updatePremium: responseImg.data.premium })
        );
      }
      yield put(UploadImageAction.uploadImageSuccess(index));
      return responseImg;
    } catch (error) {
      toastr.error("", `ارسال عکس ${index + 1} با خطا رو‌به‌رو شد.`);
      yield put(UploadImageAction.uploadImageFailure(index));
      return error;
    }
  }
}
function* get(action) {
  try {
    const response = yield call(getRequest, action.id);
    yield put(ManagerPaymentAction.getSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerPaymentAction.getFailure(message));
  }
}
function getRequest(id) {
  return paymentApi.get(id);
}

async function getImageReq(id) {
  return paymentApi.getImage(id);
}

function* getImage(action) {
  try {
    const response = yield call(getImageReq, action.id);
    yield put(ManagerPaymentAction.getImageSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerPaymentAction.getImageFailure(message));
  }
}
